module.exports = __webpack_public_path__ + "img/riviera-tulum.4b6a452b.jpg";